import { AppScreens } from '@/shared/types';

/** Префікси від довшого до коротшого, щоб не перехоплювати один одного. */
const SECTION_PATH_RULES: { prefix: string; section: AppScreens }[] = [
  {
    prefix: '/reading-plans',
    section: AppScreens.ReadingPlans,
  },
  {
    prefix: '/prayer-talks',
    section: AppScreens.PrayerExperience,
  },
  {
    prefix: '/video-bible',
    section: AppScreens.VideoBible,
  },
  {
    prefix: '/stories',
    section: AppScreens.Stories,
  },
];

const normalizeRoutePath = (raw: string): string => {
  const withoutQueryHash = raw.split(/[?#]/)[0] ?? raw;
  if (withoutQueryHash.startsWith('http')) {
    try {
      return new URL(withoutQueryHash).pathname;
    } catch {
      return withoutQueryHash;
    }
  }

  return withoutQueryHash;
};

const pathMatchesSectionPrefix = (path: string, prefix: string): boolean =>
  path === prefix || path.startsWith(`${prefix}/`);

export const getSectionNameFromPath = (rawPath: string): AppScreens => {
  let path = normalizeRoutePath(rawPath.trim());
  if (path.length > 1 && path.endsWith('/')) {
    path = path.slice(0, -1);
  }

  for (const { prefix, section } of SECTION_PATH_RULES) {
    if (pathMatchesSectionPrefix(path, prefix)) {
      return section;
    }
  }

  return AppScreens.None;
};
